module.exports = __webpack_public_path__ + "img/banner1_5.ccc9e411.png";